export const Alert = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M11.2216 2.5L19.1599 16.25C19.2331 16.3767 19.2716 16.5204 19.2716 16.6667C19.2716 16.8129 19.2331 16.9566 19.1599 17.0833C19.0868 17.21 18.9816 17.3152 18.8549 17.3884C18.7282 17.4615 18.5845 17.5 18.4382 17.5H2.56158C2.4153 17.5 2.2716 17.4615 2.14492 17.3884C2.01824 17.3152 1.91305 17.21 1.83991 17.0833C1.76677 16.9566 1.72827 16.8129 1.72827 16.6667C1.72827 16.5204 1.76678 16.3767 1.83992 16.25L9.77825 2.5C9.85139 2.37333 9.95659 2.26814 10.0833 2.19501C10.2099 2.12188 10.3536 2.08337 10.4999 2.08337C10.6462 2.08337 10.7899 2.12188 10.9166 2.19501C11.0432 2.26814 11.1484 2.37333 11.2216 2.5ZM9.66658 13.3333V15H11.3332V13.3333H9.66658ZM9.66658 7.5V11.6667H11.3332V7.5H9.66658Z"
      fill="#D43548"
    />
  </svg>
);
